import { createContext, useContext, useCallback } from "react";
import { isTestFlightLive, TESTFLIGHT_URL, GOOGLE_PLAY_URL, isAndroid, isIOS } from "@/lib/testflight";
import { useWaitlist } from "@/context/WaitlistContext";

const Ctx = createContext({
  openTestFlight: () => {},
  testFlightReady: false,
});

export function TestFlightProvider({ children }) {
  const { openWaitlist } = useWaitlist();
  const ready = isTestFlightLive();

  // Smart store routing — no modal. iPhone → App Store, Android → Play,
  // desktop/unknown → the /download page that shows both. Name kept as
  // openTestFlight so existing CTAs don't change.
  const openTestFlight = useCallback(() => {
    if (!ready) {
      // Stores not live — fall back to waitlist so the CTA is never a dead end.
      openWaitlist();
      return;
    }
    if (isAndroid() && GOOGLE_PLAY_URL) {
      window.open(GOOGLE_PLAY_URL, "_blank", "noopener");
      return;
    }
    if (isIOS() && TESTFLIGHT_URL) {
      window.open(TESTFLIGHT_URL, "_blank", "noopener");
      return;
    }
    window.location.href = "/download";
  }, [ready, openWaitlist]);

  return (
    <Ctx.Provider value={{ openTestFlight, testFlightReady: ready }}>
      {children}
    </Ctx.Provider>
  );
}

export const useTestFlight = () => useContext(Ctx);
